<div class="row g-4">
    <div class="col-12 col-xl-12">
      <mat-card>
        <mat-card-content>
          <h5 class="mb-3">View Processed Results</h5>
          <div class="row g-3">
            <!-- Course Dropdown -->
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Select Course</mat-label>
                <mat-select [(ngModel)]="selectedCourseId" (selectionChange)="onCourseChange($event.value)">
                  <mat-option *ngFor="let course of courseList" [value]="course.id">
                    {{ course.name }} -{{course?.crs_code}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

               <mat-form-field appearance="outline" class="w-100 mb-3">
        <mat-label>Select Division</mat-label>
        <mat-select [(ngModel)]="section" >
          <mat-option value="SEC0">SEC0</mat-option>
          <mat-option value="SEC1">SEC1</mat-option>
          
        </mat-select>
      </mat-form-field>
        
              <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Select Semester</mat-label>
                <mat-select [(ngModel)]="selectedSemester" (ngModelChange)="onFiltersChange()">
                  <mat-option *ngFor="let sem of semesterList" [value]="sem.number">
                    Semester {{ sem.number }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

                <mat-form-field appearance="outline" class="w-100 mb-3">
        <mat-label>Select Result Type</mat-label>
        <mat-select [(ngModel)]="result_type" >
          <mat-option value="regular">Regular</mat-option>
          <mat-option value="iti">ITI</mat-option>
          <mat-option value="puc">PUC</mat-option>
          <mat-option value="COB">COB</mat-option>
        </mat-select>
      </mat-form-field>

       <mat-form-field class="w-100" appearance="outline">
        <mat-label>Select Exam Month</mat-label>
        <mat-select [(ngModel)]="exam_month">
          <mat-option *ngFor="let month of months" [value]="month.months_name">
            {{ month.months_name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Select Exam Year</mat-label>
        <mat-select [(ngModel)]="exam_year">
          <mat-option *ngFor="let year of years" [value]="year.year_name">
            {{ year.year_name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

          </div>
          <button mat-raised-button color="primary" (click)="onFiltersChange()" [disabled]="!selectedCourseId || !selectedSemester">
            View Processed Results
          </button><br>

          <div class="search-wrapper">
              <mat-form-field appearance="outline" class="search-input">
                <mat-label>Search students</mat-label>
                <input
                  matInput
                  [(ngModel)]="searchText"
                  placeholder="Search by register no"
                />
              </mat-form-field>
            
              <button mat-flat-button color="primary" (click)="applyFilter()" class="search-btn">
                Search
              </button>
            </div>
            <button mat-flat-button color="primary" (click)="updateProcessedStats(selectedCourseId, selectedSemester, result_type, exam_month, exam_year);">
           Update Cumulative
          </button> &nbsp;&nbsp;&nbsp;
          <!-- <button [disabled]="!isCumulativeProcessed"  mat-flat-button color="primary" (click)="get_all_the_students_exel_data(selectedCourseId, selectedSemester, result_type, exam_month, exam_year);">
            Download A3 Report
          </button> -->
          <!-- [disabled]="!isCumulativeProcessed"  -->
          <button  [disabled]="!isCumulativeProcessed" mat-flat-button color="primary" (click)="getA3ReportDetails(selectedCourseId, selectedSemester, result_type, exam_month, exam_year,section)">
            view A3 Report
          </button>&nbsp;&nbsp;&nbsp;


         <button  [disabled]="!isCumulativeProcessed && !isA3Reportview" mat-flat-button color="primary" (click)="printA3();">
          Print
          </button>&nbsp;&nbsp;&nbsp;
          <!-- <button  [disabled]="!isCumulativeProcessed && !isA3Reportview" mat-flat-button color="primary" (click)="exportExcel();">
          Excel 
        </button>  -->
          
          <!-- <button mat-flat-button color="primary" (click)="getall_subjects( selectedCourseId, selectedSemester, result_type )">
            Download Full List 1
          </button> -->
        </mat-card-content>
      </mat-card>
      

    
    </div>
  </div>
  
<mat-card *ngIf="results?.length">
  <mat-card-title class="title-center">Processed Results</mat-card-title>
  <div class="mat-elevation-z8">
    
    <div class="table-wrapper">
      <table mat-table [dataSource]="results" class="mat-elevation-z8">
        <!-- Dynamic column headers -->
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
          <th mat-header-cell *matHeaderCellDef>{{ column | titlecase }}</th>
          <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row 
    *matRowDef="let row; columns: displayedColumns;" 
    [ngClass]="{ 'unprocessed-row': row.is_processed === false }">
</tr>
      </table>
    </div>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 15, 20]"
      [length]="pagination.length"
      [pageIndex]="pagination.page - 1"
      [pageSize]="pagination.limit"
      (page)="pageEvent($event)"
      *ngIf="pagination.length">
    </mat-paginator>
    
  </div>
</mat-card>

  
  <mat-card *ngIf="results?.length === 0">
    <mat-card-content>No results found.</mat-card-content>
  </mat-card>
  
 <div *ngIf="isA3Reportview" id="printSection" class="a3-sheet">
<div class="a3-sheet" *ngFor="let students of paginatedStudents; let pageIndex = index">
 <div class="top-header-container">
  <div class="top-header-row">
    <div class="programme-top-left">SEMESTER-{{ sem_roman_number }}</div>

    <div class="header-center">
      <h2>GOVERNMENT OF KARNATAKA</h2>
    </div>

    <div class="programme-top-right">
      PROGRAMME: {{ course_code }} - {{ course_name }} (DIV-{{ division }})<br />
      <span *ngIf="result_type === 'iti' || result_type === 'puc'">
       Bridge Course : ({{ result_type  | uppercase }})
      </span>
    </div>
  </div>

  <!-- Optional extra headers below if needed -->
  <div class="header-below">
    <h3>DEPARTMENT OF COLLEGIATE AND TECHNICAL EDUCATION</h3>
    <h4>BOARD OF TECHNICAL EXAMINATIONS, BENGALURU</h4>
    <h3>B.V.V.S. POLYTECHNIC (AUTONOMOUS), BAGALKOT</h3>
    <h4>PROVISIONAL MARKS SHEET - {{ sem_roman_number }} SEMESTER EXAMINATION - {{month}} {{year}}</h4>
  </div>
</div>


<hr class="line-separator" />
<div *ngIf="isRegular_for_a3" style="padding-right: 30px;">
  <table class="result-table" style="border:none">
    <div class="table-wrapper">
  <thead>
    
    <tr>
      <ng-container  *ngIf="sem_no!==5">
      <th rowspan="3" class="static-header">
        Name of the Candidate<br />
        Sl No&nbsp;&nbsp;&nbsp;Register No
        <br />
        IA Max Marks<br />
        IA Min Marks<br />
        End Exam Max<br />
        End Exam Min<br />
        Total Max Marks<br />
        Total Min Marks<br />
        Credits
      </th></ng-container>
      <ng-container *ngIf="sem_no===5">
      <th rowspan="3" class="static-header">
        Name of the Candidate<br />
        Sl No&nbsp;&nbsp;&nbsp;Register No
        <br />
        IA Max Marks<br />
        IA Min Marks<br />
        End Theory Max<br />
        End Theory Min<br />
	      End Practical Max<br />
        End Practical Min<br />
        Total Max Marks<br />
        Total Min Marks<br />
        Credits
      </th></ng-container>

     
  <ng-container *ngFor="let subject of course_subjects; let i = index">
  <!-- First column: subject number and metadata -->
   <ng-container  *ngIf="sem_no!==5">
  <th>
    0{{ i + 1 }}<br />
    <br />   
    {{ subject.cie_max !== 0 && subject.cie_max !== '0' ? subject.cie_max : '--' }}<br />
    {{ subject.cie_pass !== 0 && subject.cie_pass !== '0' ? subject.cie_pass : '--' }}<br />
    {{ subject.see_max !== 0 && subject.see_max !== '0' ? subject.see_max : '--' }}<br />
    {{ subject.see_pass !== 0 && subject.see_pass !== '0'  ? subject.see_pass : '--' }}<br />
    {{ subject.subject_max !== 0 && subject.subject_max !== '0' ? subject.subject_max : '--' }}<br />
    {{ subject.subject_min !== 0 && subject.subject_min !== '0' ? subject.subject_min : '--' }}<br />
    {{ subject.credits !== 0 && subject.credits !== '0' ? subject.credits : '--' }}<br />
  </th>
  
  <th class="verticalLetters">GRADE AWARDED</th>
</ng-container>

<ng-container  *ngIf="sem_no===5">
  <th>
    0{{ i + 1 }}<br />
    <br />
    {{ subject.cie_max }}<br />
    {{ subject.cie_pass }}<br />
    {{ subject.psee_tmax !== null && subject.psee_tmax !== '' ? subject.psee_tmax : subject.see_max }}<br />
    {{ subject.psee_tmin !== null && subject.psee_tmin !== '' ? subject.psee_tmin : subject.see_pass }}<br />
    {{ subject.psee_pmax !== 0 && subject.psee_pmax !== '' && subject.psee_pmax !== null ? subject.psee_pmax : '--' }}<br />
    {{ subject.psee_pmin !== 0 && subject.psee_pmin !== '' && subject.psee_pmin !== null ? subject.psee_pmin : '--' }}<br />
    {{ subject.subject_max !== 0 && subject.subject_max !== '' ? subject.subject_max : subject.gtot_max }}<br /> 
    {{ subject.subject_min!== 0 && subject.subject_min !== '' ? subject.subject_min : subject.gtot_min}}<br />
    {{ subject.credits }}
  </th>
  <th></th>
  <th class="verticalLetters">GRADE AWARDED</th>
  
</ng-container>
  
</ng-container>

    
      <th rowspan="3" class="verticalLetters">CREDITS EARNED</th>
      <th rowspan="3" class="bottom-text">TCPE</th>
      <th rowspan="3" class="bottom-text">CCE</th>
      <th rowspan="3" class="bottom-text">SGPA</th>
      <th rowspan="3" class="bottom-text">CGPA</th>
      <th rowspan="3" class="bottom-text">PERC(%)</th>
      <th rowspan="3" class="bottom-text">RESULTS</th>
      &nbsp;&nbsp;&nbsp;<th rowspan="3" class="bottom-text">NE</th>
    </tr>
  </thead>
  </div>
  <tr class="print-divider-row">
    <td colspan=30 class="print-divider-cell"></td>
  </tr>
  
  <tbody>
   
    <tr *ngFor="let student of students;let j = index">
     <td class="static-header">
      <div style="text-align: left;">{{student?.name}}</div>
      <div class="student-reg">{{ pageIndex * pageSize +j + 1}} &nbsp; &nbsp; &nbsp;
        {{student?.register_no}}&nbsp;
        <span *ngIf="(sem_no === 3 || sem_no === 4) && student?.k_sub5">({{ student.k_sub5 }})</span>
        <span *ngIf="sem_no === 5 || sem_no === 6">&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span *ngIf="sem_no === 5 || sem_no === 6"> {{ student.pathway }}</span>
      </div>

    </td>
    
    <!-- Subject 1 -->
      <!-- <ng-container *ngIf="sem_no!==5 && sem_no!==6"> -->
          <ng-container *ngIf="sem_no!==5">
      
 <ng-container *ngIf="course_subjects?.length >= 1">
  <td>
  {{student?.ia_sub1}} <br />
  {{student?.see_sub1}} <br />
  {{student?.result_sub1}} 
</td>

<td>
  <br />
  {{student?.grade_sub1}} <br />
</td>
</ng-container>
<!-- Subject 2 -->
 <ng-container *ngIf="course_subjects?.length >= 2">
<td>
  {{student?.ia_sub2}} <br />
  {{student?.see_sub2}} <br />
  {{student?.result_sub2}} 
</td>
<td>
  <br />
  {{student?.grade_sub2}} <br />
</td>
</ng-container>
<!-- Subject 3 -->
 <ng-container *ngIf="course_subjects?.length >= 3">
<td>
  {{student?.ia_sub3}} <br />
  {{student?.see_sub3}} <br />
  {{student?.result_sub3}} 
</td>
<td>
  <br />
  {{student?.grade_sub3}} <br />
</td>
</ng-container>
<!-- Subject 4 -->
<ng-container *ngIf="course_subjects?.length >= 4">
<td>
  {{student?.ia_sub4}} <br />
  {{student?.see_sub4}} <br />
  {{student?.result_sub4}} 
</td>
<td>
  <br />
  {{student?.grade_sub4}} <br />
</td>
</ng-container>
<!-- Subject 5 -->
 <ng-container *ngIf="course_subjects?.length >= 5">
<td>
  {{student?.ia_sub5}} <br />
  {{student?.see_sub5}} <br />
  {{student?.result_sub5}} 
</td>
<td>
  <br />
  {{student?.grade_sub5}} <br />
</td>
</ng-container>
<!-- Subject 6 -->
  <ng-container *ngIf="course_subjects?.length >= 6">
<td>
  {{student?.ia_sub6}} <br />
  {{student?.see_sub6}} <br />
  {{student?.result_sub6}} 
</td>
<td>
  <br />
  {{student?.grade_sub6}} <br />
</td>
</ng-container>
<!-- Subject 7 -->
  <ng-container *ngIf="course_subjects?.length >= 7">
<td>
  {{student?.ia_sub7}} <br />
  {{student?.see_sub7}} <br />
  {{student?.result_sub7}} 
</td>
<td>
  <br />
  {{student?.grade_sub7}} <br />
</td>
</ng-container>
<!-- Subject 8 -->
  <ng-container *ngIf="course_subjects?.length >= 8">
<td>
  {{student?.ia_sub8}} <br />
  {{student?.see_sub8}} <br />
  {{student?.result_sub8}} 
</td>
<td>
  <br />
  {{student?.grade_sub8}} <br />
</td>
</ng-container>

<ng-container *ngIf="course_subjects?.length >= 9">
<td>
  {{student?.ia_sub9}} <br />
  {{student?.see_sub9}} <br />
  {{student?.result_sub9}} 
</td>
<td>
  <br />
  {{student?.grade_sub9}} <br />
</td>
</ng-container>
</ng-container>

    <!-- Subject 1 -->
<ng-container *ngIf="sem_no==5">
      
 <ng-container *ngIf="course_subjects?.length >= 1">
<ng-container *ngIf=" (sem_no === 5 && (student?.course_code !== '78' && student?.course_code !== '88'))">
  <td>
  {{student?.ia_sub1}} <br />
  {{student?.see_sub1}} <br />
  {{student?.see_sub1p}} <br />
</td>
<td>
  <br />
   {{student?.result_sub1}} <br />
  {{student?.result_sub1p}} <br />
</td>
<td>
  <br />
  {{student?.grade_sub1}} <br />
</td>
</ng-container>
<ng-container *ngIf="(sem_no==5 && student?.course_code === '78') ||(sem_no==5 && student?.course_code === '88')">
  <td>
  {{student?.ia_sub1}} <br />
  {{student?.see_sub1}} <br />
  {{student?.result_sub1}} <br />
</td>
<td>
</td>
<td>
  <br />
  {{student?.grade_sub1}} <br />
</td>
</ng-container>

</ng-container>
<!-- Subject 2 -->
 <ng-container *ngIf="course_subjects?.length >= 2">
  <ng-container *ngIf="sem_no === 5 && (student?.course_code !== '78' && student?.course_code !== '88')">
<td>
  {{student?.ia_sub2}} <br />
  {{student?.see_sub2}} <br />
  {{student?.see_sub2p}} <br />
</td>
<td>
  <br />
   {{student?.result_sub2}} <br />
  {{student?.result_sub2p}} <br />
</td>
<td>
  <br />
  {{student?.grade_sub2}} <br />
</td>
</ng-container>
<ng-container *ngIf="(sem_no==5 && student?.course_code === '78') || (sem_no==5 && student?.course_code === '88')">
<td>
  {{student?.ia_sub2}} <br />
  {{student?.see_sub2}} <br />
  {{student?.result_sub2}} <br />
</td>
<td></td>
<td>
  <br />
  {{student?.grade_sub2}} <br />
</td>
</ng-container>

</ng-container>
<!-- Subject 3 -->
 <ng-container *ngIf="course_subjects?.length >= 3">
<td>
  {{student?.ia_sub3}} <br />
  {{student?.see_sub3}} <br />
  {{student?.see_sub3p}} <br />
</td>
<td>
  <br />
   {{student?.result_sub3}} <br />
  {{student?.result_sub3p}} <br />
</td>
<td>
  <br />
  {{student?.grade_sub3}} <br />
</td>
</ng-container>
<!-- Subject 4 -->
<ng-container *ngIf="course_subjects?.length >= 4">
<td>
  {{student?.ia_sub4}} <br />
  {{student?.see_sub4}} <br />
   {{student?.see_sub4p}} <br />
</td>
<td>
  <br />
   {{student?.result_sub4}} <br />
  {{student?.result_sub4p}} <br />
</td>
<td>
  <br />
  {{student?.grade_sub4}} <br />
</td>
</ng-container>
<!-- Subject 5 -->
 <ng-container *ngIf="course_subjects?.length >= 5">
<td>
  {{student?.ia_sub5}} <br />
  {{student?.see_sub5}} <br />
   {{student?.see_sub5p}} <br />
</td>
<td>
  <br />
   {{student?.result_sub5}} <br />
  {{student?.result_sub5p}} <br />
</td>
<td>
  <br />
  {{student?.grade_sub5}} <br />
</td>
</ng-container>
<!-- Subject 6 -->
  <ng-container *ngIf="course_subjects?.length >= 6">
<td>
  {{student?.ia_sub6}} <br />
  {{student?.see_sub6}} <br />
   {{student?.see_sub6p}} <br />
</td>
<td>
  <br />
   {{student?.result_sub6}} <br />
  {{student?.result_sub6p}} <br />
</td>
<td>
  <br />
  {{student?.grade_sub6}} <br />
</td>
</ng-container>
<!-- Subject 7 -->
  <ng-container *ngIf="course_subjects?.length >= 7">
<td>
  {{student?.ia_sub7}} <br />
  {{student?.see_sub7}} <br />
   {{student?.see_sub7p}} <br /> 
</td>
<td>
  <br />
   {{student?.result_sub7}} <br />
  {{student?.result_sub7p}} <br />
</td>
<td>
  <br />
  {{student?.grade_sub7}} <br />
</td>
</ng-container>
<!-- Subject 8 -->
  <ng-container *ngIf="course_subjects?.length >= 8">
<td>
  {{student?.ia_sub8}} <br />
  {{student?.see_sub8}} <br />
   {{student?.see_sub8p}} <br />
</td>
<td>
  <br />
   {{student?.result_sub8}} <br />
  {{student?.result_sub8p}} <br />
</td>
<td>
  <br />
  {{student?.grade_sub8}} <br />
</td>
</ng-container>

<ng-container *ngIf="course_subjects?.length >= 9">
<td>
  {{student?.ia_sub9}} <br />
  {{student?.see_sub9}} <br />
   {{student?.see_sub9p}} <br /> 
</td>
<td>
  <br />
   {{student?.result_sub9}} <br />
  {{student?.result_sub9p}} <br />
</td>
<td>
  <br />
  {{student?.grade_sub9}} <br />
</td>
</ng-container>
<ng-container *ngIf="course_subjects?.length >= 10">
<td>
  {{student?.ia_sub10}} <br />
  {{student?.see_sub10}} <br />
   {{student?.see_sub10p}} <br /> 
</td>
<td>
  <br />
   {{student?.result_sub10}} <br />
  {{student?.result_sub10p}} <br />
</td>
<td>
  <br />
  {{student?.grade_sub10}} <br />
</td>
</ng-container>
<ng-container *ngIf="course_subjects?.length >= 11">
<td>
  {{student?.ia_sub11}} <br />
  {{student?.see_sub11}} <br />
   {{student?.see_sub11p}} <br /> 
</td>
<td>
  <br />
   {{student?.result_sub11}} <br />
  {{student?.result_sub11p}} <br />
</td>
<td>
  <br />
  {{student?.grade_sub11}} <br />
</td>
</ng-container>
<ng-container *ngIf="course_subjects?.length >= 12">
<td>
  {{student?.ia_sub12}} <br />
  {{student?.see_sub12}} <br />
   {{student?.see_sub12p}} <br /> 
</td>
<td>
  <br />
   {{student?.result_sub12}} <br />
  {{student?.result_sub12p}} <br />
</td>
<td>
  <br />
  {{student?.grade_sub12}} <br />
</td>
</ng-container>
</ng-container>
<td>{{student?.total_earned_credits}}</td>
<td>{{student?.weighted_grade_points}}</td>
<td>{{student?.cumulative_credits_earned}}</td>
<td>{{student?.sgpa}}</td>
<td>{{student?.cgpa === 'Credit(s) Pending' ? 'Pending' : student?.cgpa }}</td>
<td class="bottom-texts">{{student?.total_percentage==='Not Applicable' ?'NA':student?.total_percentage}}</td>
<td class="result-view">{{student?.overall_result}}</td>
&nbsp;&nbsp;&nbsp;<td style="border: none;">{{student?.NE}}</td> 
<td style="border: none;"></td> 
    </tr>
    <tr></tr>

    </tbody>
  </table>
  </div>





















  <div *ngIf="!isRegular_for_a3" style="padding-right: 30px;">
  <table class="result-table" style="border:none">
    <div class="table-wrapper">
  <thead>
    
    <tr>
      <ng-container *ngIf="sem_no===3 || sem_no===4">
      <th rowspan="3" class="static-header">
        Name of the Candidate<br />
        Sl No&nbsp;&nbsp;&nbsp;Register No
        <br />
        IA Max Marks<br />
        IA Min Marks<br />
        End Exam Max<br />
        End Exam Min<br />
        Total Max Marks<br />
        Total Min Marks<br />
      </th></ng-container>

     
  <ng-container *ngFor="let subject of course_subjects; let i = index">
  <!-- First column: subject number and metadata -->
   <ng-container  *ngIf="sem_no===3 || sem_no===4">
  <th>
    0{{ i + 1 }}<br />
    <br />   
    {{ subject.cie_max !== 0 && subject.cie_max !== '0' ? subject.cie_max : '--' }}<br />
    {{ subject.cie_pass !== 0 && subject.cie_pass !== '0' ? subject.cie_pass : '--' }}<br />
    {{ subject.see_max !== 0 && subject.see_max !== '0' ? subject.see_max : '--' }}<br />
    {{ subject.see_pass !== 0 && subject.see_pass !== '0'  ? subject.see_pass : '--' }}<br />
    {{ subject.subject_max !== 0 && subject.subject_max !== '0' ? subject.subject_max : '--' }}<br />
    {{subject.subject_min !== 0 && subject.subject_min !== '0' ? subject.subject_min : '--' }}<br />
  </th>
</ng-container>  


</ng-container>
      <th rowspan="3" >GRAND <br />
       TOTAL <br />
      {{ iti_data?.total_cie_max }}<br />
      {{ iti_data?.total_cie_pass }}<br />
      {{ iti_data?.total_see_max }}<br />
      {{ iti_data?.total_see_pass }}<br />
      {{ iti_data?.total_subject_max }}<br />
      {{ iti_data?.total_subject_min }}
      </th>
      <th rowspan="3" class="bottom-text">RESULTS</th>
    </tr>
  </thead>
  </div>
  <tr class="print-divider-row">
    <td colspan=30 class="print-divider-cell"></td>
  </tr>
  
  <tbody>
   
    <tr *ngFor="let student of students;let j = index">
     <td class="static-header">
      <div style="text-align: left;">{{student?.name}}</div>
      <div class="student-reg">{{ pageIndex * students.length +j + 1}} &nbsp; &nbsp; &nbsp;{{student?.register_no}}
      </div>

    </td>
    
  
<ng-container *ngIf="sem_no==3 || sem_no==4">
      
 <ng-container *ngIf="course_subjects?.length >= 1">
  <td>
  {{student?.ia_sub1}} <br />
  {{student?.see_sub1}} <br />
  {{student?.result_sub1}} 
</td>
</ng-container>
<!-- Subject 2 -->
 <ng-container *ngIf="course_subjects?.length >= 2">
<td>
  {{student?.ia_sub2}} <br />
  {{student?.see_sub2}} <br />
  {{student?.result_sub2}} 
</td>
</ng-container>
<!-- Subject 3 -->
 <ng-container *ngIf="course_subjects?.length >= 3">
<td>
  {{student?.ia_sub3}} <br />
  {{student?.see_sub3}} <br />
  {{student?.result_sub3}} 
</td>
</ng-container>

</ng-container>


<td>{{student?.iti_puc_grandtotal}}<br/>
<!-- {{student?.iti_puc_see_result}}<br/>
{{ student?.iti_puc_overal_result === 'FAIL' ? 'F' : 'P' }} -->
</td>
&nbsp;&nbsp;
<td class="result-view">{{student?.iti_puc_overal_result}}</td>

<td style="border: none;"></td>
    </tr>
    <tr></tr>

    </tbody>
  </table>
  </div>
   <hr class="line-separator" />
  <div class="sub-dict" >
   <ng-container *ngFor="let subject of course_subjects; let i = index">
 
 
    <span >0{{ i + 1 }}
      &nbsp;{{subject.subject_name}}&nbsp;&nbsp;&nbsp;&nbsp;
    </span>
    </ng-container> <br /><br />
   <span>*NA - Not Applicable</span>
    </div>
 
  
<div class="page-footer">
      Page {{ pageIndex + 1 }}
    </div>
    
<div class="footer" *ngIf="pageIndex + 1 === paginatedStudents.length">
 
</div>
</div> 





 <div *ngIf="isExcelReportview" id="excelSection" class="a3-sheet">

 <div class="top-header-container">
  <div class="top-header-row">
    <div class="programme-top-left">SEMESTER-{{ sem_roman_number }}</div>

    <div class="header-center">
      <h2>GOVERNMENT OF KARNATAKA</h2>
    </div>

    <div class="programme-top-right">
      PROGRAMME: {{ course_code }} - {{ course_name }} (DIV-{{ division }})
    </div>
  </div>

  <!-- Optional extra headers below if needed -->
  <div class="header-below">
    <h3>DEPARTMENT OF COLLEGIATE AND TECHNICAL EDUCATION</h3>
    <h4>BOARD OF TECHNICAL EXAMINATIONS, BENGALURU</h4>
    <h3>B.V.V.S. POLYTECHNIC (AUTONOMOUS), BAGALKOT</h3>
    <h4>PROVISIONAL MARKS SHEET - {{ sem_roman_number }} SEMESTER EXAMINATION - {{month}} {{year}}</h4>
  </div>
</div>


<hr class="line-separator" />
<div style="padding-right: 30px;">
  <table class="result-table" style="border:none">
    <div class="table-wrapper">
  <thead>
    
    <tr>
      <ng-container  *ngIf="sem_no!==5">
      <th rowspan="3" class="static-header">
        Name of the Candidate<br />
        Sl No&nbsp;&nbsp;&nbsp;Register No
        <br />
        IA Max Marks<br />
        IA Min Marks<br />
        End Exam Max<br />
        End Exam Min<br />
        Total Max Marks<br />
        Total Min Marks<br />
        Credits
      </th></ng-container>
      <ng-container *ngIf="sem_no===5">
      <th rowspan="3" class="static-header">
        Name of the Candidate<br />
        Sl No&nbsp;&nbsp;&nbsp;Register No
        <br />
        IA Max Marks<br />
        IA Min Marks<br />
        End Theory Max<br />
        End Theory Min<br />
	      End Practical Max<br />
        End Practical Min<br />
        Total Max Marks<br />
        Total Min Marks<br />
        Credits
      </th></ng-container>

     
  <ng-container *ngFor="let subject of course_subjects; let i = index">
  <!-- First column: subject number and metadata -->
   <ng-container  *ngIf="sem_no!==5">
  <th>
    0{{ i + 1 }}<br />
    <br />   
    {{ subject.cie_max }}<br />
    {{ subject.cie_pass }}<br />
    {{ subject.see_max }}<br />
    {{ subject.see_pass }}<br />
    {{ subject.subject_max }}<br />
    {{ subject.subject_min }}<br />
    {{ subject.credits }}
  </th>
  <th class="verticalLetters">GRADE AWARDED</th>
</ng-container>

<ng-container  *ngIf="sem_no===5">
  <th>
    0{{ i + 1 }}<br />
    <br />
    {{ subject.cie_max }}<br />
    {{ subject.cie_pass }}<br />
    {{ subject.psee_tmax }}<br />
    {{ subject.psee_tmin }}<br />
    {{ subject.psee_pmax }}<br />
    {{ subject.psee_pmin }}<br />
    {{ subject.gtot_max }}<br />
    {{ subject.gtot_min }}<br />
    {{ subject.credits }}
  </th>
  <th class="verticalLetters">GRADE AWARDED</th>
  
</ng-container>
  
</ng-container>

    
      <th rowspan="3" class="verticalLetters">CREDITS EARNED</th>
      <th rowspan="3" class="bottom-text">TCPE</th>
      <th rowspan="3" class="bottom-text">CCE</th>
      <th rowspan="3" class="bottom-text">SGPA</th>
      <th rowspan="3" class="bottom-text">CGPA</th>
      <th rowspan="3" class="bottom-text">PERC(%)</th>
      <th rowspan="3" class="bottom-text">RESULTS</th>
      <th rowspan="3" class="bottom-text">NE</th>
    </tr>
  </thead>
  </div>
  <tr class="print-divider-row">
    <td colspan=40 class="print-divider-cell"></td>
  </tr>
  
  <tbody>
   
    <tr *ngFor="let student of processed_results;let j = index">
     <td class="static-header">
      <div style="text-align: left;">{{student?.name}}</div>
      <div class="student-reg">{{ j + 1}} &nbsp;{{student?.register_no}} </div>

    </td>
    
    <!-- Subject 1 -->
     <ng-container *ngIf="course_subjects?.length >= 1">
  <td>
  {{student?.ia_sub1}} <br />
  {{student?.see_sub1}} <br />
  {{student?.result_sub1}} 
</td>

<td>
  <br />
  {{student?.grade_sub1}} <br />
</td>
</ng-container>
<!-- Subject 2 -->
 <ng-container *ngIf="course_subjects?.length >= 2">
<td>
  {{student?.ia_sub2}} <br />
  {{student?.see_sub2}} <br />
  {{student?.result_sub2}} 
</td>
<td>
  <br />
  {{student?.grade_sub2}} <br />
</td>
</ng-container>
<!-- Subject 3 -->
 <ng-container *ngIf="course_subjects?.length >= 3">
<td>
  {{student?.ia_sub3}} <br />
  {{student?.see_sub3}} <br />
  {{student?.result_sub3}} 
</td>
<td>
  <br />
  {{student?.grade_sub3}} <br />
</td>
</ng-container>
<!-- Subject 4 -->
<ng-container *ngIf="course_subjects?.length >= 4">
<td>
  {{student?.ia_sub4}} <br />
  {{student?.see_sub4}} <br />
  {{student?.result_sub4}} 
</td>
<td>
  <br />
  {{student?.grade_sub4}} <br />
</td>
</ng-container>
<!-- Subject 5 -->
 <ng-container *ngIf="course_subjects?.length >= 5">
<td>
  {{student?.ia_sub5}} <br />
  {{student?.see_sub5}} <br />
  {{student?.result_sub5}} 
</td>
<td>
  <br />
  {{student?.grade_sub5}} <br />
</td>
</ng-container>
<!-- Subject 6 -->
  <ng-container *ngIf="course_subjects?.length >= 6">
<td>
  {{student?.ia_sub6}} <br />
  {{student?.see_sub6}} <br />
  {{student?.result_sub6}} 
</td>
<td>
  <br />
  {{student?.grade_sub6}} <br />
</td>
</ng-container>
<!-- Subject 7 -->
  <ng-container *ngIf="course_subjects?.length >= 7">
<td>
  {{student?.ia_sub7}} <br />
  {{student?.see_sub7}} <br />
  {{student?.result_sub7}} 
</td>
<td>
  <br />
  {{student?.grade_sub7}} <br />
</td>
</ng-container>
<!-- Subject 8 -->
  <ng-container *ngIf="course_subjects?.length >= 8">
<td>
  {{student?.ia_sub8}} <br />
  {{student?.see_sub8}} <br />
  {{student?.result_sub8}} 
</td>
<td>
  <br />
  {{student?.grade_sub8}} <br />
</td>
</ng-container>

<ng-container *ngIf="course_subjects?.length >= 9">
<td>
  {{student?.ia_sub9}} <br />
  {{student?.see_sub9}} <br />
  {{student?.result_sub9}} 
</td>
<td>
  <br />
  {{student?.grade_sub9}} <br />
</td>
</ng-container>

<td>{{student?.total_earned_credits}}</td>
<td>{{student?.weighted_grade_points}}</td>
<td>{{student?.cumulative_credits_earned}}</td>
<td>{{student?.sgpa}}</td>
<td>{{student?.cgpa === 'Credit(s) Pending' ? 'Pending' : student?.cgpa }}</td>
<td class="bottom-texts">{{student?.total_percentage==='Not Applicable' ?'NA':student?.total_percentage}}</td>
<td class="result-view">{{student?.overall_result}}</td>
<td style="border: none;"></td> 
<td style="border: none;"></td> 
    </tr>

    </tbody>
  </table>
  </div>
   <hr class="line-separator" />
  <div class="sub-dict" >
   <ng-container *ngFor="let subject of course_subjects; let i = index">
 
 
    <span >0{{ i + 1 }}
      &nbsp;{{subject.subject_name}}&nbsp;&nbsp;&nbsp;&nbsp;
    </span>
    </ng-container> <br />
   <span>*NA - Not Applicable</span>
    </div>
 
  
<div class="page-footer">
      Page {{ pageIndex + 1 }}
    </div>
    
<div class="footer" *ngIf="pageIndex + 1 === paginatedStudents.length">
  <!-- <hr class="line-separator" /> -->
  <div class="footer">
  <div class="signatures">
    <div class="left">
      <p><strong>Controller of Examinations,</strong><br />
      <strong>Semester Systems,</strong><br />
      <strong>B.V.V.S. Polytechnic (Autonomous),</strong><br />
      <strong>BAGALKOT.</strong></p>
    </div>
    <div class="right">
      <p><strong>Chairman and Principal,</strong><br />
      <strong>Examinations(Semester Systems),</strong><br />
      <strong>B.V.V.S. Polytechnic (Autonomous),</strong><br />
      <strong>BAGALKOT.</strong></p>
    </div>

  </div>
</div>
</div>


